import { format, isAfter, setDate } from "date-fns";
import { useLocation } from "react-router-dom";
import React from "react";
import { Quill } from "react-quill";

export function contactFormat(value: any) {
  if (!value) return;
  value = value.replace(/^(\d{5})/, "$1 ");
  return value;
}

export function numberFormat(item: any) {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
  })
    .format(item)
    .replace(/₹/g, "");
}

export function numberFormatWithCrDr(item: any, nature: string) {
  let formattedNumber = "";
  nature = nature === "CR" ? "Cr" : "Dr";

  nature = item < 0 ? (nature === "Cr" ? "Dr" : "Cr") : nature;

  item = Math.abs(item);
  formattedNumber = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
  })
    .format(item)
    .replace(/₹/g, "");

  formattedNumber = formattedNumber + " " + nature;
  return formattedNumber;
}

export function getSingleSelected(selectedValue: any, sourceList: any) {
  let result = sourceList.find((o) => o.value === selectedValue);
  return result;
}

export function numDifferentiation(value, decimalFixes) {
  let result = value.toFixed(decimalFixes);
  let val = Math.abs(value);
  if (val >= 10000000) {
    result = (val / 10000000).toFixed(decimalFixes);
  } else if (val >= 100000) {
    result = (val / 100000).toFixed(decimalFixes);
  } else if (val >= 1000) {
    result = (val / 1000).toFixed(decimalFixes);
  } else {
    result = val.toFixed(decimalFixes);
  }

  if (value < 0) {
    return "-₹" + result;
  } else {
    return "₹" + result;
  }
}

export function numDifferentiationForText(value) {
  let result = "";
  let val = Math.abs(value);
  if (val >= 10000000) {
    result = "Crores";
  } else if (val >= 100000) {
    result = "Lakhs";
  } else if (val >= 1000) {
    result = "Thousands";
  } else {
    result = "Rupees";
  }
  return result;
}

export function getCurrentFinancialYear() {
  let financialYear = "";
  let startYear = 0;
  let endYear = 0;
  let docDate = new Date();

  if (new Date().getMonth() > 2) {
    startYear = docDate.getFullYear();
    endYear = docDate.getFullYear() + 1;
    let tempFinancialYear = startYear + "-" + endYear;
    financialYear = tempFinancialYear;
  } else {
    startYear = docDate.getFullYear() - 1;
    endYear = docDate.getFullYear();
    let tempFinancialYear = startYear + "-" + endYear;
    financialYear = tempFinancialYear;
  }
  return financialYear;
}

export function getCurrentFinancialYearStartDate() {
  let startYearDate = new Date();
  let startYear = 0;
  let docDate = new Date();
  if (new Date().getMonth() > 2) {
    startYear = docDate.getFullYear();
    startYearDate = new Date(startYear, 3, 1);
  } else {
    startYear = docDate.getFullYear() - 1;
    startYearDate = new Date(startYear, 3, 1);
  }
  let finalstartYearDate = format(new Date(startYearDate), "yyyy-MM-dd");
  return finalstartYearDate;
}

export function getCurrentFinancialYearEndDate() {
  let endYearDate = new Date();
  let endYear = 0;
  let docDate = new Date();
  if (new Date().getMonth() > 2) {
    endYear = docDate.getFullYear() + 1;
    endYearDate = new Date(endYear, 2, 31);
  } else {
    endYear = docDate.getFullYear();
    endYearDate = new Date(endYear, 2, 31);
  }
  let finalendYearDate = format(new Date(endYearDate), "yyyy-MM-dd");
  return finalendYearDate;
}

export function getStartDate() {
  let startDate = new Date();
  if (startDate.getMonth() === 3) {
    startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  } else {
    startDate = new Date(
      new Date().getFullYear(),
      new Date().getMonth() - 1,
      1,
    );
  }
  return startDate;
}

export function getEndDate() {
  let endDate = new Date();
  if (endDate.getMonth() === 3) {
    endDate = new Date();
  } else {
    endDate.setDate(0);
  }
  return endDate;
}

export function getJournalEnteriesCapitalizeType(value: any) {
  let result: any = "JE";
  let val = value.toLowerCase();
  if (val === "payment") {
    result = "VOUCHER_PAYMENT";
  } else if (val === "receipt") {
    result = "VOUCHER_RECEIPT";
  } else if (val === "contra") {
    result = "VOUCHER_CONTRA";
  } else if (val === "journal") {
    result = "VOUCHER_JOURNAL";
  }
  return result;
}

export function getSaleTypeName(value: any) {
  let result: any = "Invoices";
  let val = value.toLowerCase();
  if (val === "tax-invoice") {
    result = "SALE";
  } else if (val === "proforma-invoice") {
    result = "PROFORMA";
  } else if (val === "quotation-estimate") {
    result = "QUOTATION";
  } else if (val === "labour-invoice") {
    result = "LABOUR";
  } else if (val === "composition-invoice") {
    result = "SALE";
  }
  return result;
}

export function getNameSelected(selectedValue: any, sourceList: any) {
  let result = sourceList.find(
    (o: { value: any }) => o.value === selectedValue,
  );
  return result === undefined || result === "" ? "" : result.label;
}

export const convertToUpperCase = (value: any) => {
  return value?.toString()?.toUpperCase();
};

export function getMonthStartAndEndDate(month: number, year: number) {
  if (month < 1 || month > 12) {
    throw new Error(
      "Invalid month number. Month number should be between 1 and 12.",
    );
  }

  const startDate = new Date(year, month - 1, 1); // Subtract 1 from month to adjust for zero-based indexing
  const endDate = new Date(year, month, 0); // Day 0 of the next month is the last day of the current month

  return {
    startDate,
    endDate,
  };
}

export function isElementVisible(element) {
  return element.offsetWidth > 0 || element.offsetHeight > 0;
}

export function ExportFilesFunction(
  attachmentName: string,
  attachmentType: string,
  attachmentData: any,
) {
  let iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window?.MSStream;
  let isChrome: any =
    navigator.userAgent.toLowerCase().indexOf("CriOS") > -1 ||
    navigator.vendor.toLowerCase().indexOf("google") > -1;
  let iOSVersion: any = [];
  if (iOS) {
    iOSVersion = navigator?.userAgent
      .match(/OS [\d_]+/i)[0]
      .substr(3)
      .split("_")
      .map((n) => parseInt(n));
  }
  let contentType = "";
  let blobMediaType = "";
  if (attachmentType === "pdf") {
    contentType = "application/pdf";
    blobMediaType = `data:application/pdf;df:`;
  } else {
    contentType = "application/msexcel";
    blobMediaType = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,`;
  }
  let binary = atob(attachmentData.replace(/\s/g, ""));
  let len = binary.length;
  let buffer = new ArrayBuffer(len);
  let view = new Uint8Array(buffer);
  for (let i = 0; i < len; i++) {
    view[i] = binary.charCodeAt(i);
  }
  let linkElement = document.createElement("a");
  try {
    let hrefUrl = "";
    let blob: any = "";
    if (iOS && !isChrome && iOSVersion[0] <= 12) {
      blob = blobMediaType + attachmentData;
      hrefUrl = blob;
    } else {
      if (iOS && !isChrome) {
        contentType = "application/octet-stream";
      }
      blob = new Blob([view], { type: contentType });
      hrefUrl = window.URL.createObjectURL(blob);
    }
    linkElement.setAttribute("href", hrefUrl);
    linkElement.setAttribute("target", "_blank");
    if ((iOS && (iOSVersion[0] > 12 || isChrome)) || !iOS) {
      linkElement.setAttribute("download", attachmentName);
    }
    let clickEvent = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: false,
    });
    linkElement.dispatchEvent(clickEvent);
  } catch (ex) {
    console.log("file export error: ", ex);
  }
}

export const handleFocus = (event) => event?.target?.select();

export function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export function removeSpacesAndLowercase(input) {
  return input.replace(/\s+/g, "").toLowerCase();
}

export const getStartDateOnInit = (userContext) => {
  const edMonth = new Date(userContext.financialYearEndDate).getMonth() + 1;
  const edYear = new Date(userContext.financialYearEndDate).getFullYear();
  if (userContext.financialYear !== userContext.currentFinancialYear) {
    return new Date(edYear + "-" + edMonth + "-" + "01");
  } else {
    return getStartDate();
  }
};
export const getEndDateOnInit = (userContext) => {
  if (userContext.financialYear !== userContext.currentFinancialYear) {
    return new Date(userContext.financialYearEndDate);
  } else {
    return getEndDate();
  }
};

export const getDiscountedValue = (
  value: number,
  discountType: string,
  discountValue: number,
) => {
  if (discountType === "%") {
    return value - value * (discountValue / 100);
  } else {
    return value - discountValue;
  }
};

export function addDays(date, days) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

export function getLabel(value: string, options: Array<any>) {
  return options?.find((x) => x.value === value)?.label || "";
}

export const dataURLtoFile = (dataurl, filename) => {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
};

// Age Logic Function
export const getAge = (
  dob: Date,
): { Year: number; Month: number; Day: number } => {
  let today = new Date();
  let Year = today.getFullYear() - dob.getFullYear();
  let Month = today.getMonth() - dob.getMonth();
  let Day = today.getDate() - dob.getDate();

  if (Day < 0) {
    Month -= 1;
    Day += new Date(today.getFullYear(), today.getMonth(), 0).getDate();
  }

  if (Month < 0) {
    Year -= 1;
    Month += 12;
  }
  if (isAfter(dob, today)) {
    Year = 0;
    Month = 0;
    Day = 0;
  }
  return { Year, Month, Day };
};

// BMI Logic Funcation
export const calculateBMI = (heightCm: number, weightKg: number): number => {
  let result: number | null = null;
  if (heightCm === 0) {
    result = 0;
  } else {
    result = (weightKg / (heightCm * heightCm)) * 10000;
  }
  return parseFloat(result.toFixed(2));
};

export const calculateBSA = (heightCm: number, weightKg: number): number => {
  const result =
    0.007184 * Math.pow(heightCm, 0.725) * Math.pow(weightKg, 0.425);
  return parseFloat(result.toFixed(2));
};

export const getDayName = (inputDate: string) => {
  const date = new Date(inputDate); // Directly use inputDate, assuming it's in 'YYYY-MM-DD' format.
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  return days[date.getDay()];
};

export const lastOpdVisitTime = (
  lastOpdDate: Date,
): { Year: number; Month: number; Day: number } => {
  let today = new Date();
  let Year = today.getFullYear() - lastOpdDate.getFullYear();
  let Month = today.getMonth() - lastOpdDate.getMonth();
  let Day = today.getDate() - lastOpdDate.getDate();

  if (Day < 0) {
    Month -= 1;
    Day += new Date(today.getFullYear(), today.getMonth(), 0).getDate();
  }

  if (Month < 0) {
    Year -= 1;
    Month += 12;
  }

  if (lastOpdDate > today) {
    Year = 0;
    Month = 0;
    Day = 0;
  }

  return { Year, Month, Day };
};

export const getTimeDifference = (startDate: Date, endDate: Date): string => {
  let minutes = Math.floor(
    (endDate.getTime() - startDate.getTime()) / (1000 * 60),
  );

  let days = Math.floor(minutes / 1440);
  minutes -= days * 1440;

  let hours = Math.floor(minutes / 60);
  minutes -= hours * 60;

  return `${days > 0 ? `${days} day(s) ` : ""}${
    hours > 0 ? `${hours} hr(s) ` : ""
  }${minutes} min(s)`;
};

export const doseFractionOptions = [
  { label: "¼", value: 0.25 },
  { label: "½", value: 0.5 },
  { label: "¾", value: 0.75 },
  { label: "1½", value: 1.5 },
  { label: "2½", value: 2.5 },
  { label: "3½", value: 3.5 },
  { label: "4½", value: 4.5 },
];

const doseFractionByLabel: Record<string, number> = Object.fromEntries(
  doseFractionOptions.map((option) => [option.label, option.value]),
);

/**
 * Fraction buttons map to one number each.
 * "1 ½" is treated as "1½". A plain number such as 2 or 0.3 is kept as that number.
 */
export const parseDoseDisplayValue = (input: unknown): number | null => {
  if (input === null || input === undefined) return null;

  const text = String(input).trim();
  if (!text) return null;

  const fractionValue = doseFractionByLabel[text.replace(/\s+/g, "")];
  if (fractionValue !== undefined) return fractionValue;

  if (/^\d+$/.test(text) || /^\d*\.\d+$/.test(text)) {
    const parsed = parseFloat(text);
    return Number.isFinite(parsed) ? parsed : null;
  }

  return null;
};

/** Prefer the number parsed from the label. Keep the stored calc only when the label cannot be parsed. */
export const resolveDoseCalcValue = (
  display: unknown,
  calc: unknown,
): number | null => {
  const parsed = parseDoseDisplayValue(display);
  if (parsed !== null) return parsed;
  if (calc === null || calc === undefined || calc === "") return null;
  const stored = typeof calc === "number" ? calc : parseFloat(String(calc));
  return Number.isFinite(stored) ? stored : null;
};

export const decimalToFraction = (decimal, printUnitCode = "") => {
  const supportedUnits = [
    "TABLET",
    "CAPSULE",
    "GUMMY",
    "SUPPOSITORY",
    "SACHET",
    "MINI_BOTTLE",
  ];

  if (typeof decimal !== "number") return null;

  const isClose = (a, b, epsilon = 0.01) => Math.abs(a - b) < epsilon;

  const wholePart = Math.floor(decimal);
  const fractionPart = decimal - wholePart;

  // If unit is not supported, return plain decimal string
  if (!supportedUnits.includes(printUnitCode)) {
    return decimal.toString();
  }

  const fractionOption = doseFractionOptions.find((option) =>
    isClose(decimal, option.value),
  );
  if (fractionOption) {
    return fractionOption.label;
  }

  // Handle exact whole number
  if (isClose(fractionPart, 0)) {
    return `${wholePart}`;
  }

  // Not a known fraction — return decimal string
  return decimal.toString();
};

// ---- Insert Text at Cursor in Quill Editor ----
export const insertTextAtCursor = (
  quillRef: React.MutableRefObject<any>,
  text: string,
) => {
  const editor = quillRef.current?.getEditor?.();
  if (!editor) return;

  const parser = new DOMParser();
  const parsedText =
    parser.parseFromString(text, "text/html").body.textContent?.trim() ?? "";
  if (!parsedText) return;

  // get current selection (valid if button didn't blur editor)
  let selection = editor.getSelection();
  let insertPosition: number;

  if (selection && typeof selection.index === "number") {
    // insert at current cursor
    insertPosition = selection.index;
  } else {
    // fallback → append at end
    insertPosition = Math.max(0, editor.getLength() - 1);
  }

  // check if there is text before insertion
  const textBefore =
    insertPosition > 0 ? editor.getText(0, insertPosition) : "";
  const hasContentBefore = textBefore.trim().length > 0;
  const lastChar = hasContentBefore ? textBefore.trim().slice(-1) : "";
  const needsSemicolon = hasContentBefore && lastChar !== ";";

  const prefix = needsSemicolon ? "; " : "";
  const contentToInsert = `${prefix}${parsedText} `;

  editor.focus();
  editor.insertText(insertPosition, contentToInsert, Quill.sources.USER);
  editor.setSelection(insertPosition + contentToInsert.length, 0);
};

// export const insertTextAtCursor = (
//   quillRef: React.MutableRefObject<any>,
//   text: string
// ) => {
//   const editor = quillRef.current?.getEditor?.();
//   if (!editor) return;

//   const parser = new DOMParser();
//   const parsedText =
//     parser.parseFromString(text, "text/html").body.textContent?.trim() ?? "";
//   if (!parsedText) return;

//   let selection = editor.getSelection();
//   let insertPosition: number;

//   if (selection && typeof selection.index === "number") {
//     insertPosition = selection.index;
//   } else {
//     insertPosition = Math.max(0, editor.getLength() - 1);
//   }

//   const textBefore =
//     insertPosition > 0 ? editor.getText(0, insertPosition) : "";
//   const hasContentBefore = textBefore.trim().length > 0;
//   const lastChar = hasContentBefore ? textBefore.trim().slice(-1) : "";
//   const needsSemicolon = hasContentBefore && lastChar !== ";";

//   const prefix = needsSemicolon ? "; " : "";
//   const contentToInsert = `${prefix}${parsedText} `;

//   editor.insertText(insertPosition, contentToInsert, Quill.sources.SILENT);
// };

export const shouldKeepQuillEditorOpen = (
  quillRef: React.MutableRefObject<any>,
) => {
  const quill = quillRef.current?.getEditor?.();
  if (!quill) return false;

  if (quill.hasFocus()) {
    return true;
  }

  const quillContainer = quill.container as HTMLElement | undefined;
  const quillWrapper = quillContainer?.parentElement;
  if (!quillWrapper) {
    return false;
  }

  const activeElement = document.activeElement;
  if (
    activeElement instanceof HTMLElement &&
    quillWrapper.contains(activeElement)
  ) {
    return true;
  }

  return Boolean(quillWrapper.querySelector(".ql-picker.ql-expanded"));
};

export const handleFocusOutActiveElelment = () => {
  const activeEl = document.activeElement;
  if (activeEl instanceof HTMLElement) {
    activeEl.blur();
  }
};
